import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price);
        total += price * item.quantity;
      }
    });
    return total.toFixed(2);
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
    } else {
      alert("Your cart is empty.");
    }
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />
      <main className="cart-page">
        <div className="cart-header">
          <h1>My Cart</h1>
        </div>

        <div className="cart-container">
          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <div className="empty-cart-content">
                <h2>Cart Empty</h2>
                <p>Your cart is currently empty.</p>
                <Link onClick={toTop} to="/" className="continue-shopping-btn">
                  CONTINUE SHOPPING
                </Link>
              </div>
            </div>
          ) : (
            <div className="cart-content">
              {/* Left Side - Cart Items */}
              <div className="cart-items-section">
                {cartItems.map((item) => {
                  const product = getProductById(item.id);
                  return (
                    <div key={`${item.id}-${item.size}`} className="cart-item">
                      <div className="cart-item-image">
                        <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                          <img src={product.images[0]} alt={product.name} />
                        </Link>
                      </div>

                      <div className="cart-item-info">
                        <div className="item-header">
                          <Link
                            to={`/shopDetails/${product.id}`}
                            onClick={toTop}
                            className="item-name"
                          >
                            {product.name}
                          </Link>
                          <div className="item-price">
                            ${(product.price * item.quantity).toFixed(2)}
                          </div>
                        </div>

                        <div className="item-details">
                          <p className="item-attribute">
                            <span className="attribute-label">Size:</span>
                            <span className="attribute-value">{item.size}</span>
                          </p>
                        </div>

                        <div className="item-actions">
                          <div className="quantity-selector">
                            <button
                              className="qty-btn"
                              onClick={() =>
                                handleUpdateQuantity(
                                  item.id,
                                  item.size,
                                  item.quantity - 1
                                )
                              }
                              aria-label="Decrease quantity"
                            >
                              −
                            </button>
                            <span className="qty-display">{item.quantity}</span>
                            <button
                              className="qty-btn"
                              onClick={() =>
                                handleUpdateQuantity(
                                  item.id,
                                  item.size,
                                  item.quantity + 1
                                )
                              }
                              aria-label="Increase quantity"
                            >
                              +
                            </button>
                          </div>

                          <button
                            className="remove-btn"
                            onClick={() => removeFromCart(item.id, item.size)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Right Side - Cart Summary */}
              <div className="cart-summary-section">
                <div className="cart-summary-sticky">
                  <div className="summary-content">
                    <div className="summary-row subtotal-row">
                      <span className="summary-label">Subtotal</span>
                      <span className="summary-value">${subtotal}</span>
                    </div>

                    <p className="shipping-note">
                      Shipping & taxes calculated at checkout
                    </p>

                    <button className="checkout-btn" onClick={handleCheckout}>
                      CHECKOUT
                    </button>

                    <div className="payment-methods">
                      <p className="payment-label">We Accept</p>
                      <div className="payment-icons">
                        <span className="payment-icon">💳</span>
                        <span className="payment-text">All Major Cards</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CartPage;
